import api from '../../api';
import {
  GET_VIP_LIST_FAILURE,
  GET_VIP_LIST_SUCCESS,
} from '../types';

const state = {
  list: [],
  listUpdated: (new Date()),
};


const actions = {
  getVipList({ commit }, query) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.getVipList(query).then(response => {
        if (!response.ok) {
          commit(GET_VIP_LIST_FAILURE)
          api.stopLoader()
          return reject()
        }
        commit(GET_VIP_LIST_SUCCESS, {
          vipList: response.body.data
        })
        api.stopLoader()
        return resolve()
      }, response => {
        commit(GET_VIP_LIST_FAILURE)
        api.stopLoader()
        return reject()
      })
    })
  },
  createVip({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()

      api.createVip(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()

            return reject(response.body.$error);
          } else {
            api.stopLoader()

            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()

          return reject(response.body.$error);
        })
    })
  },
  deleteVip({ commit }, id) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.deleteVip(id)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          }
          api.stopLoader()
          return resolve(response.body.$success);
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })
    })
  },

};

const mutations = {

  [GET_VIP_LIST_FAILURE](state) {
    state.list = []
  },
  [GET_VIP_LIST_SUCCESS](state, action) {
    state.list = action.vipList;
    state.listUpdated = new Date();
  },
};

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/vip.js